// extracted by mini-css-extract-plugin
module.exports = {"contato":"Telefone_contato__3zvkH","icone":"Telefone_icone__3_jdi","nome":"Telefone_nome__2pW2p","numero":"Telefone_numero__M1_qZ","opcao":"Telefone_opcao__2xs6p"};